module.exports = __webpack_public_path__ + "img/2.f5f457d4.png";